import React from 'react';
import { is } from '../../../services';
import { Link } from '../../link';
import { Icon } from '../../icon';
import { Badge } from '../../badge';
import clsx from 'clsx';
// accessibility
const a11y = { role: 'menuitem' };
/**
 * Menu Item Component - Menu Item component
 * @deprecated
 * @param children {ReactNode} Children for Menu Item
 * @param className {string} Additionnal CSS Classes
 * @param to {string} Link
 * @param arrow {boolean} Add arrow for MenuItem
 * @param badge {string|number} Add custom Badge
 * @param icon {IconName} Add custom Icon
 * @param onClick {Function} onClick Event for Menu Item
 * @param active {boolean} If active
 */
const MenuItem = ({ active, children, className, to, arrow, badge, icon, onClick, testId, ...others }) => {
    const classes = clsx('menu-item', active && is('active'), arrow && 'with-arrow', className);
    if (!children) {
        return React.createElement("div", null);
    }
    return (React.createElement("li", { "data-testid": testId, ...a11y, onClick: onClick && onClick }, React.Children.toArray(children).map((child, i) => {
        const item = (React.createElement(React.Fragment, null,
            icon && React.createElement(Icon, { name: icon }),
            child,
            badge && React.createElement(Badge, null, badge)));
        return ((child && typeof child.valueOf() === 'string' && (React.createElement(Link, { key: i, className: classes, ...others, to: to, removeLinkClass: true }, item))) || React.createElement(React.Fragment, { key: i }, item));
    })));
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map